// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

export const SvgIconNumber4 = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: "1em", height: "1em", viewBox: "0 0 24 24", ...props },
    <path
      fillRule="evenodd"
      d="M12 4a8 8 0 100 16 8 8 0 000-16M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12"
    />,
    <path d="M14.092 14.928h1.582v-1.4h-1.582V9.804h-1.54v3.724h-2.52l2.212-6.58H10.55l-2.296 6.748v1.232h4.298V17h1.54z" />
  );
export default SvgIconNumber4;
